export default __webpack_public_path__ + "static/media/bachFlower3.59fcd3f7.jpg";